var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIconTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 35.5984C29.302 35.5984 33.6 31.3004 33.6 25.9984C33.6 20.6965 29.302 16.3984 24 16.3984C18.6981 16.3984 14.4 20.6965 14.4 25.9984C14.4 31.3004 18.6981 35.5984 24 35.5984ZM23.4657 22.6C23.0974 22.3545 22.624 22.3316 22.2338 22.5404C21.8436 22.7493 21.6 23.1559 21.6 23.5984V28.3984C21.6 28.841 21.8436 29.2476 22.2338 29.4564C22.624 29.6653 23.0974 29.6424 23.4657 29.3969L27.0657 26.9969C27.3995 26.7743 27.6 26.3997 27.6 25.9984C27.6 25.5972 27.3995 25.2225 27.0657 25L23.4657 22.6Z",
    fill: "#9A9AAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconTwo);
export default __webpack_public_path__ + "static/media/play_icon_two.684e4be74bebf32aaea83a409d4a569b.svg";
export { ForwardRef as ReactComponent };